export default __webpack_public_path__ + "static/media/earthrise.38b5ac31.jpg";